import axios from "axios";
import authHeader from "./auth-header";
import getmainurl from "./tools.service";

// list -------------------------------------------------------------
const listAll = async () => {
    return await axios({
        url: getmainurl() + '/api/v1/roles/', method: 'get', headers: authHeader(),
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

// default export ---------------------------------------------------
const role = {
    listAll
};

export default role;